<script>
import ImagePreviewModal from '@/components/widgets/modal-image-preview.vue';

export default {
  components: { ImagePreviewModal },

  props: {
    soalStats: Object,
    listItem: Object,
    getQuestionNumber: Function,
    currentQuestion: Object,
    is_instruksi: Number,
    mengerjakan: Function,

    // Jawaban
    isBooleanQuestion: Boolean,
    // currentQuestion: Object,
    currentQuestionOptionList: Object,
    currentQuestionShuffleOptionList: Object,
    answers: Array,
    currentIndex: Number,
    hasImageOptions: Boolean,
    currentPage: Number,
    selectAnswer: Function,

    // navigasi
    // currentQuestion: Object,
    isLastQuestion: Boolean,
    isAllAnswered: Boolean,
    openProgressFinal: Function,
    nextQuestion: Function,
    // is_instruksi: Number,
    nextSoal: Function,
    last_page: Number,
    index_soal: Number,
    status_pengerjaan: Number,
    // mengerjakan: Function,
  },

  data() {
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      abjad : ["A", "B", "C", "D"],
      // modal-image-preview
      imagePreview: {
        show: false,
        url: null,
      },
    };
  },

  methods: {
    // modal-image-preview
    openImagePreview(url, event) {
      event.stopPropagation();
      this.imagePreview.url = url;
      this.imagePreview.show = true;
    },
  },
};
</script>

<template>
  <div v-if="currentQuestion" class="mym-question-body">
    <!-- NUMBER -->
    <div class="mym-card-case mb-3" v-if="currentQuestion?.soal_text != null">
      <div class="mym-card-jumbotron-header">
        <div class="mym-card-jumbotron-icon text-light">
          <i class="fa fa-file-alt"></i>
        </div>

        <h3 class="mym-card-jumbotron-title">Studi Kasus</h3>
      </div>

      <div class="mym-card-jumbotron-content">
        {{ currentQuestion?.soal_text }}
      </div>
    </div>

    <div class="mym-question-navigation">
      <div class="mym-qn-header">
        <div class="mym-question-number">
          Soal
          <span class="mym-actived-number">{{ index_soal }}</span> /
          {{ soalStats.total }}
        </div>
      </div>

      <div class="mym-question-section">
        <div class="mb-2">
          <img
            v-if="currentQuestion?.soal_image"
            :src="BACKEND_URL + currentQuestion?.soal_image"
            class="mym-question-image"
          />
          <div class="mym-question-text">
            <div v-html="currentQuestion?.pertanyaan"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- ================= OPTIONS SECTION ================= -->
    <div class="mym-options-section">
      <div class="mym-options" :class="{ 'grid-mode': hasImageOptions }">
        <div
          v-for="(jawaban, i) in currentQuestionShuffleOptionList"
          :key="i"
          class="mym-option-card"
          :class="{ active: jawaban.selected }"
          @click="selectAnswer(currentQuestion, jawaban)"
        >
          <!-- @click="localAnswers[currentIndex] = opt.kode_jawaban" -->

          <div
            v-if="jawaban.jawaban && jawaban.jawaban.startsWith('/storage/file_manager')"
            class="option-image-wrapper"
          >
            <img
              :src="BACKEND_URL + jawaban.jawaban"
              class="option-image"
            />
            <button
              class="option-image-preview-btn"
              type="button"
              @click="openImagePreview(BACKEND_URL + jawaban.jawaban, $event)"
            >
              <i class="fas fa-search-plus"></i>
            </button>
          </div>

          <div class="option-content">
            <div class="option-label">
              <span v-if="jawaban.selected">✔</span>
              <!-- <span v-else>{{ jawaban.kode_jawaban }}</span> -->
              <span v-else>{{ abjad[i] }}</span>
            </div>

            <div
              class="option-text"
              v-if="!jawaban.jawaban || !jawaban.jawaban.startsWith('/storage/file_manager')"
            >
              {{ jawaban.jawaban }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="mym-footer justify-content-end">
      
      <button
        v-if="last_page - 1 !== index_soal && status_pengerjaan === 0"
        class="mym-btn mym-bg-primary"
        type="button"
        @click="nextSoal(1)"
      >
        Selanjutnya
        <i class="fas fa-chevron-right ms-1"></i>
      </button>

      <button
        v-if="last_page - 1 === index_soal || status_pengerjaan === 1"
        class="mym-btn mym-bg-success"
        type="button"
        @click="$emit('modalProgressFinal')"
        style="width: 200px"
      >
        Selesai
        <i class="fas fa-check ms-1"></i>
      </button>
    </div>
  </div>

  <ImagePreviewModal
    v-model="imagePreview.show"
    :image-url="imagePreview.url"
  />
</template>

<style scoped>
.option-image-wrapper {
  position: relative;
  display: inline-flex;
  width: 100%;
}

.option-image-wrapper .option-image-preview-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.2s;
  background: rgba(66, 80, 128, 0.55);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mym-option-card:hover .option-image-preview-btn {
  opacity: 1;
}
</style>